import React, { PropsWithChildren, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../../common/types';
import { SMLFormContainer } from '../../../../SMLFormContainer/SMLFormContainer';
import { SMLRoutes } from '../../../../../../routing/sml/SMLRoutes';
import { ErrorAPIResult } from '../../../../../../redux/api/utils/isSuccessfulResult';

interface PresaveWidgetFormContainerProps {
  accountId: number;
  smartLinkId: number;
  isLoading: boolean;
  error?: ErrorAPIResult['error'];
  onSubmit?: () => void;
  onDelete?: () => void;
  submitDisabled?: boolean;
  submitButtonTitle?: string;
}

/**
 * The chrome every state of the pre-save block editor shares: one title, one
 * way back to the Creator, and the same footer. The three states differ in
 * what they put inside it, not around it.
 */
const PresaveWidgetFormContainerComponent: React.FC<PropsWithChildren<PresaveWidgetFormContainerProps>> = ({
  children,
  accountId,
  smartLinkId,
  isLoading,
  error,
  onSubmit,
  onDelete,
  submitDisabled,
  submitButtonTitle,
}) => {
  const intl = useIntl();
  const backRouteParams = useMemo(() => ({ accountId, smartLinkId }), [accountId, smartLinkId]);

  return (
    <SMLFormContainer
      backRoute={SMLRoutes.details}
      backRouteParams={backRouteParams}
      title={intl.formatMessage({ id: 'app.sml.presave.block.title', defaultMessage: 'Catalog links' })}
      onSubmit={onSubmit}
      onDelete={onDelete}
      isLoading={isLoading}
      error={error}
      submitDisabled={submitDisabled}
      submitButtonTitle={submitButtonTitle}
    >
      {children}
    </SMLFormContainer>
  );
};

export const PresaveWidgetFormContainer = TypedMemo(PresaveWidgetFormContainerComponent);
